import React from 'react'
import './Carousel.css';
import $ from 'jquery'; 
import {Link} from 'react-router-dom';

function Carousel({shuffled}) {

    $(document).ready(function () {
        var itemsMainDiv = ('.MultiCarousel');
        var itemsDiv = ('.MultiCarousel-inner');
        var itemWidth = "";
    
        $('.leftLst, .rightLst').click(function () {
            var condition = $(this).hasClass("leftLst");
            if (condition)
                click(0, this);
            else
                click(1, this)
        });
    
        ResCarouselSize();
    
        $(window).resize(function () {
            ResCarouselSize();
        });
    
        //this function define the size of the items
        function ResCarouselSize() {
            var incno = 0;
            var dataItems = ("data-items");
            var itemClass = ('.item');
            var id = 0;
            var btnParentSb = '';
            var itemsSplit = '';
            var sampwidth = $(itemsMainDiv).width();
            var bodyWidth = $('body').width();
            $(itemsDiv).each(function () {
                id = id + 1;
                var itemNumbers = $(this).find(itemClass).length;
                btnParentSb = $(this).parent().attr(dataItems);
                itemsSplit = btnParentSb.split(',');
                $(this).parent().attr("id", "MultiCarousel" + id);
    
    
                if (bodyWidth >= 1200) {
                    incno = itemsSplit[3];
                    itemWidth = sampwidth / incno;
                }
                else if (bodyWidth >= 992) {
                    incno = itemsSplit[2];
                    itemWidth = sampwidth / incno;
                }
                else if (bodyWidth >= 768) {
                    incno = itemsSplit[1];
                    itemWidth = sampwidth / incno;
                }
                else {
                    incno = itemsSplit[0];
                    itemWidth = sampwidth / incno;
                }
                $(this).css({ 'transform': 'translateX(0px)', 'width': itemWidth * itemNumbers });
                $(this).find(itemClass).each(function () {
                    $(this).outerWidth(itemWidth);
                });
    
                $(".leftLst").addClass("over");
                $(".rightLst").removeClass("over");
    
            });
        }
    
    
        //this function used to move the items
        function ResCarousel(e, el, s) {
            var leftBtn = ('.leftLst');
            var rightBtn = ('.rightLst');
            var translateXval = '';
            var divStyle = $(el + ' ' + itemsDiv).css('transform');
            var values = divStyle.match(/-?[\d\.]+/g);
            var xds = Math.abs(values[4]);
            if (e == 0) {
                translateXval = parseInt(xds) - parseInt(itemWidth * s);
                $(el + ' ' + rightBtn).removeClass("over");
    
                if (translateXval <= itemWidth / 2) {
                    translateXval = 0;
                    $(el + ' ' + leftBtn).addClass("over");
                }
            }
            else if (e == 1) {
                var itemsCondition = $(el).find(itemsDiv).width() - $(el).width();
                translateXval = parseInt(xds) + parseInt(itemWidth * s);
                $(el + ' ' + leftBtn).removeClass("over");
    
                if (translateXval >= itemsCondition - itemWidth / 2) {
                    translateXval = itemsCondition;
                    $(el + ' ' + rightBtn).addClass("over");
                }
            }
            $(el + ' ' + itemsDiv).css('transform', 'translateX(' + -translateXval + 'px)');
        }
    
        //It is used to get some elements from btn
        function click(ell, ee) {
            var Parent = "#" + $(ee).parent().attr("id");
            var slide = $(Parent).attr("data-slide");
            ResCarousel(ell, Parent, slide);
        }
    
    });
        

    const filteredArray = shuffled.filter(item => item.type==="featured")
    const mapFilter = filteredArray.map(item => {
        let sumArr = item.body.split('');
        let summ = []
        for (var i=0; i<70; i++){
            summ.push(sumArr[i]);
        }
        let summary = summ.join("");

        let sumArr2 = item.title.split('');
        let summ2 = []
        for (var i=0; i<20; i++){
            summ2.push(sumArr2[i]);
        }
        let titSummary = summ2.join("");
        
        let slug = item.title.toLowerCase().trim().split(/\s+/).join('-');
        return (
            <div className="item" key={item.id}>
                <div className="card mb-2">
                    <img className="card-img-top" src={`/${item.image}`}
                    alt="Card image cap"/>
                    <div className="card-body">
                    <Link to={`/posts/${slug}`}><h4 className="card-title">{titSummary}...</h4></Link>
                    <p className="card-text">{summary}...</p>
                    <hr className="post-border-2"/>
                    <p className="category-name-2">{item.category}</p>
                    </div>
                </div>
            </div>
        )
    })
    return (
        <div className="px-5">
            <div className="row">
		<div className="MultiCarousel" data-items="1,3,4,4" data-slide="1" id="MultiCarousel"  data-interval="1000">
            <div className="MultiCarousel-inner">
                {mapFilter}
            </div>
            <button className="btn btn-primary leftLst">&lt;</button>
            <button className="btn btn-primary rightLst">&gt;</button>
        </div>
	</div>
	
        </div>
    )
}

export default Carousel
